import React, { useState } from "react";
import MyOrders from "./MyOrders";
import MyProfile from "./MyProfile";
import Sidebar from "./SideBarMenu";
import Logout from "./Logout";
import AddressList from "./MyAddress";
import UpdatePassword from "./UpdatePassword";

const UserDashboard = () => {
  const [activeTab, setActiveTab] = useState("orders");

  const renderContent = () => {
    switch (activeTab) {
      case "orders":
        return <MyOrders />;
      case "profile":
        return <MyProfile />;
      case "logout":
        return <Logout />;
      case "address":
        return <AddressList />;
      case "password":
        return <UpdatePassword />;
      default:
        return <MyOrders />;
    }
  };

  return (
    <div style={styles.container}>
      <Sidebar setActiveTab={setActiveTab} />
      <div style={styles.content}>{renderContent()}</div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "100vh",
  },
  content: {
    flex: 1,
    padding: "20px",
  },
};

export default UserDashboard;
